import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '../store'
import { sync } from 'vuex-router-sync'
import './components'
import vuetify from './plugins/vuetify';
import VueFlags from "@growthbunker/vueflags"



Vue.config.productionTip = false
sync(store, router)

Vue.use(VueFlags, {
  // Specify the path of the folder where the flags are stored.
  iconPath: '/assets/flags/',
});

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
